export default () => {
  window.documentViewer.getAnnotationHistoryManager().redo();
};
